/* MonKoku Maison · Proben-Baukasten: vier 5-ml-Proben wählen, Set-Preis greift automatisch */
(function () {
  'use strict';
  var SK = 'mks:sel';

  function init(el) {
    if (el.__mks) return;
    var M = window.MKS;
    if (!M) return;
    el.__mks = 1;
    var cfg = {
      code: (el.getAttribute('data-code') || '').trim(),
      size: parseInt(el.getAttribute('data-size'), 10) || 4,
      deal: parseInt(el.getAttribute('data-deal'), 10) || 0
    };
    var grid = el.querySelector('[data-grid]');
    var tools = el.querySelector('[data-tools]');
    var tray = el.querySelector('[data-tray]');
    var live = el.querySelector('[data-live]');
    var items = [], by = {}, sel = [], filt = { g: '', f: [], q: '' }, busy = false, msgT = 0;
    var esc = M.esc;

    function say(t) {
      if (!live) return;
      live.textContent = t;
      clearTimeout(msgT);
      msgT = setTimeout(function () { live.textContent = ''; }, 5000);
    }
    function save() { try { localStorage.setItem(SK, JSON.stringify(sel)); } catch (e) { /* egal */ } }
    function ok(x) { return x && x.v5 && x.v5[2] === 1; }

    function sum() { return sel.reduce(function (s, h) { return s + (by[h] && by[h].v5 ? by[h].v5[1] : 0); }, 0); }

    function visible() {
      var terms = M.norm(filt.q).trim().split(/\s+/).filter(Boolean);
      return items.filter(function (x) {
        if (filt.g === 'd' && x.g === 'h') return false;
        if (filt.g === 'h' && x.g === 'd') return false;
        if (filt.g === 'u' && x.g !== 'u') return false;
        if (filt.f.length && !filt.f.some(function (f) { return x.f.indexOf(f) > -1; })) return false;
        return terms.every(function (t) { return x.q.indexOf(t) > -1; });
      }).sort(function (a, b) {
        var oa = ok(a) ? 0 : 1, ob = ok(b) ? 0 : 1;
        if (oa !== ob) return oa - ob;
        if (a.best !== b.best) return a.best ? -1 : 1;
        return a.t.localeCompare(b.t, 'de');
      });
    }

    function chip(label, on, attr) {
      return '<button type="button" class="mks-chip' + (on ? ' is-on' : '') + '" ' + attr + ' aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(label) + '</button>';
    }

    function renderTools() {
      var fams = Object.keys(M.FAM).filter(function (f) { return items.some(function (x) { return x.f.indexOf(f) > -1; }); });
      tools.innerHTML =
        '<label class="mks-search"><span class="sr-only">Duft oder Note suchen</span><input type="search" data-q placeholder="Duft oder Note suchen, z. B. Vanille" value="' + esc(filt.q) + '" autocomplete="off"></label>' +
        '<div class="mks-chips" role="group" aria-label="Für wen">' +
        chip('Alle', !filt.g, 'data-g=""') + chip('Für Damen', filt.g === 'd', 'data-g="d"') + chip('Für Herren', filt.g === 'h', 'data-g="h"') + chip('Unisex', filt.g === 'u', 'data-g="u"') +
        '</div>' +
        '<div class="mks-chips mks-chips--scroll" role="group" aria-label="Duftwelt">' +
        fams.map(function (f) { return chip(M.FAM[f], filt.f.indexOf(f) > -1, 'data-f="' + f + '"'); }).join('') +
        '</div>';
    }
    function syncTools() {
      Array.prototype.forEach.call(tools.querySelectorAll('[data-g]'), function (b) {
        var on = b.getAttribute('data-g') === filt.g;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(tools.querySelectorAll('[data-f]'), function (b) {
        var on = filt.f.indexOf(b.getAttribute('data-f')) > -1;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function card(x, i) {
      var on = sel.indexOf(x.h) > -1, av = ok(x);
      var fam = x.f.slice(0, 3).map(function (f) { return M.FAM[f] || f; }).join(' · ');
      return '<article class="mks-card' + (on ? ' is-on' : '') + (av ? '' : ' is-out') + '">' +
        '<button type="button" class="mks-card__pick" data-pick="' + esc(x.h) + '"' + (av ? '' : ' disabled') + ' aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + esc(x.t) + (on ? ' aus dem Set entfernen' : av ? ' zum Set hinzufügen' : ' – aktuell ausverkauft') + '">' +
        '<span class="mks-card__img">' + (x.img ? '<img src="' + esc(x.img) + '" alt="' + esc(x.t) + ' Extrait de Parfum" width="480" height="480" loading="' + (i < 6 ? 'eager' : 'lazy') + '" decoding="async">' : '') + '</span>' +
        '<span class="mks-card__check" aria-hidden="true"></span>' +
        (av ? '' : '<span class="mks-card__out">Ausverkauft</span>') +
        '</button>' +
        '<div class="mks-card__body">' +
        '<h3 class="mks-card__t"><a href="' + esc(x.url) + '">' + esc(x.t) + '</a></h3>' +
        (x.k ? '<p class="mks-card__k">' + esc(x.k) + '</p>' : '') +
        (fam ? '<p class="mks-card__f">' + esc(fam) + '</p>' : '') +
        '<p class="mks-card__p">5 ml · ' + (x.v5 ? M.money(x.v5[1]) : '') + '</p>' +
        '</div></article>';
    }

    function renderGrid() {
      var list = visible();
      grid.setAttribute('aria-busy', 'false');
      grid.innerHTML = list.length ? list.map(card).join('') : '<p class="mks-empty">Dazu haben wir gerade keinen Duft. Versuche einen anderen Begriff oder nimm einen Filter heraus.</p>';
    }

    function renderTray() {
      var n = sel.length, s = sum(), left = cfg.size - n, full = n === cfg.size;
      var slots = '';
      for (var i = 0; i < cfg.size; i++) {
        var x = by[sel[i]];
        slots += '<li>' + (x ? '<button type="button" class="mks-slot is-filled" data-rm="' + esc(x.h) + '" aria-label="' + esc(x.t) + ' entfernen">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" width="96" height="96" decoding="async">' : '') + '<span class="mks-slot__x" aria-hidden="true">×</span></button>' : '<span class="mks-slot" aria-hidden="true">' + (i + 1) + '</span>') + '</li>';
      }
      var price;
      if (!n) price = cfg.deal ? 'Wähle ' + cfg.size + ' Proben – zusammen ' + M.money(cfg.deal) : 'Wähle deine Proben';
      else if (full && cfg.deal) price = '<s>' + M.money(s) + '</s> <b>' + M.money(cfg.deal) + '</b> · du sparst ' + M.money(Math.max(0, s - cfg.deal));
      else if (cfg.deal) price = M.money(s) + ' · mit ' + left + (left === 1 ? ' weiteren Probe' : ' weiteren Proben') + ' nur ' + M.money(cfg.deal);
      else price = M.money(s);
      var label = busy ? 'Einen Moment …' : full && cfg.deal ? 'Set für ' + M.money(cfg.deal) + ' in den Warenkorb' : n ? n + (n === 1 ? ' Probe' : ' Proben') + ' in den Warenkorb' : 'In den Warenkorb';
      tray.innerHTML = '<div class="mks-tray__in"><ol class="mks-tray__slots">' + slots + '</ol>' +
        '<div class="mks-tray__info"><p class="mks-tray__count">' + n + ' von ' + cfg.size + ' gewählt</p><p class="mks-tray__price">' + price + '</p></div>' +
        '<button type="button" class="mks-tray__cta" data-add' + (n && !busy ? '' : ' disabled') + '>' + esc(label) + '</button></div>';
      el.classList.toggle('has-sel', n > 0);
    }

    function refresh() { renderGrid(); renderTray(); }

    function updateCard(h) {
      var bs = grid.querySelectorAll('[data-pick]'), x = by[h], on = sel.indexOf(h) > -1;
      for (var i = 0; i < bs.length; i++) {
        if (bs[i].getAttribute('data-pick') !== h) continue;
        bs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        bs[i].setAttribute('aria-label', x.t + (on ? ' aus dem Set entfernen' : ' zum Set hinzufügen'));
        bs[i].parentNode.classList.toggle('is-on', on);
      }
    }

    function toggle(h) {
      var x = by[h];
      if (!x || !ok(x)) return;
      var i = sel.indexOf(h);
      if (i > -1) { sel.splice(i, 1); say(x.t + ' entfernt.'); }
      else {
        if (sel.length >= cfg.size) { say('Dein Set ist voll. Entferne einen Duft, um zu tauschen.'); return; }
        sel.push(h);
        say(x.t + ' hinzugefügt. ' + sel.length + ' von ' + cfg.size + ' gewählt.');
      }
      save();
      updateCard(h);
      renderTray();
    }

    function add() {
      if (busy || !sel.length) return;
      var ids = sel.map(function (h) { return { id: by[h].v5[0], quantity: 1 }; });
      busy = true; renderTray();
      M.addToCart(ids, sel.length === cfg.size ? cfg.code : '').then(function () {
        say(sel.length === cfg.size ? 'Dein Set liegt im Warenkorb.' : 'Die Proben liegen im Warenkorb.');
        sel = []; save();
      }).catch(function (e) {
        say('Das hat nicht geklappt: ' + (e && e.message ? e.message : 'Bitte versuche es erneut.'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).then(function () { busy = false; refresh(); });
    }

    el.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-pick],[data-rm],[data-add],[data-g],[data-f],[data-retry],[data-clear]') : null;
      if (!t) return;
      if (t.hasAttribute('data-pick')) toggle(t.getAttribute('data-pick'));
      else if (t.hasAttribute('data-rm')) toggle(t.getAttribute('data-rm'));
      else if (t.hasAttribute('data-add')) add();
      else if (t.hasAttribute('data-g')) { filt.g = t.getAttribute('data-g'); syncTools(); renderGrid(); }
      else if (t.hasAttribute('data-f')) {
        var f = t.getAttribute('data-f'), i = filt.f.indexOf(f);
        if (i > -1) filt.f.splice(i, 1); else filt.f.push(f);
        syncTools(); renderGrid();
      } else if (t.hasAttribute('data-retry')) start();
    });
    el.addEventListener('input', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-q')) { filt.q = e.target.value; renderGrid(); }
    });

    function start() {
      grid.setAttribute('aria-busy', 'true');
      grid.innerHTML = '<div class="mks-skel" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>';
      M.load().then(function (all) {
        items = all.filter(function (x) { return x.v5; });
        by = {}; items.forEach(function (x) { by[x.h] = x; });
        var want = [];
        try { want = JSON.parse(localStorage.getItem(SK) || '[]'); } catch (e) { want = []; }
        var m = /[?&]pick=([^&#]+)/.exec(location.search);
        if (m) { try { want = decodeURIComponent(m[1]).split(','); } catch (e) { /* ignorieren */ } }
        sel = [];
        want.forEach(function (h) { if (by[h] && ok(by[h]) && sel.indexOf(h) < 0 && sel.length < cfg.size) sel.push(h); });
        renderTools(); refresh();
      }).catch(function () {
        grid.setAttribute('aria-busy', 'false');
        grid.innerHTML = '<div class="mks-empty"><p>Unsere Düfte konnten gerade nicht geladen werden.</p><button type="button" class="mks-chip is-on" data-retry>Erneut versuchen</button> <a class="mks-link" href="' + M.root + 'collections/5-ml-proben-extrait-de-parfum">Zum Proben-Sortiment</a></div>';
      });
    }
    renderTray();
    start();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mks]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();